// Alifia Povlsen — Portfolio (real cases from apgraphicdesignstudios.myportfolio.com)

export const designer = {
  name: 'Alifia Povlsen',
  fullName: 'Alifia Amalia Salsabila Putri Birk Povlsen',
  wordmark: 'ALIFIA · POVLSEN',
  role: 'Grafisk Designer',
  email: 'putri.povlsen@hotmail.com',
  phone: '+45 53 68 69 67',
  phoneHref: 'tel:+4553686967',
  instagram: '@ap_graphicdesignstudios',
  instagramURL: 'https://www.instagram.com/ap_graphicdesignstudios',
  location: 'Aalborg, Danmark',
  linkedIn: 'https://www.linkedin.com/in/alifia-a-s-p-b-povlsen/',
  linkedInHandle: '/in/alifia-a-s-p-b-povlsen',
  taglineDA: 'Jeg er en designer med en dyb passion for storytelling. Min interesse for film har givet mig en dyb forståelse for at formidle historier i enhver kontekst. Jeg brænder for at skabe designløsninger, der strategisk og autentisk formidler dine budskaber og værdier – klart, effektivt og med gennemslagskraft.',
  taglineShort: 'En designer med en dyb passion for storytelling. Inspireret af film skaber jeg designløsninger, der formidler dine budskaber — strategisk, autentisk og med gennemslagskraft.'
};

export const skills = [
  'Logo & Branding', 'Visuel Identitet', 'Grafisk Design',
  'Webdesign', '3D-animation', 'AI-design',
  'Infografik', 'Editorial Design', 'Kampagne Design',
  'Print & Produktion', 'Strategisk Kommunikation', 'Kreativ Ledelse'
];

export const services = [
  { id: 1, title: 'Logo & Branding', desc: 'Wordmarks, visuelle identiteter og editorial systemer designet til at kommunikere med præcision.', accent: '#B3543E' },
  { id: 2, title: 'Grafisk Design', desc: 'Tryksager, plakater og editorial layouts der lever lige så meget på væggen som på siden.', accent: '#4A6B82' },
  { id: 3, title: 'Webdesign', desc: 'Landingsider og digitale flader der balancerer det editorial og det funktionelle.', accent: '#E8B33C' },
  { id: 4, title: 'Visuel Identitet', desc: 'Helstøbte visuelle systemer — fra logo til kampagne — for brands der vil fortælle.', accent: '#3E5F4C' }
];

// Adobe CDN base — URLs are signed with hash parameter, so we use a helper.
const CDN = 'https://cdn.myportfolio.com/938e731b-e76f-4324-b9f2-773cdffcd95a';
const img = (name, hash) => `${CDN}/${name}?h=${hash}`;

// Podium-case assets (uploadet via Emergent assets)
const PODIUM_ASSETS = 'https://customer-assets.emergentagent.com/job_film-craft-studio-2/artifacts';
const podiumImg = (filename) => `${PODIUM_ASSETS}/${filename}`;

export const cases = [
  {
    id: 'podium',
    slug: 'podium',
    title: 'Praktik & Studiejob',
    subtitle: 'Podium',
    category: 'Brand & Editorial',
    year: '2026',
    descriptor: 'Praktik hos Podium — designguides og hjemmeside for Restaurant Podium, Aalborgtårnet og Skydepavillonen.',
    cover: '/podium/podium-hero.jpg',
    heroImage: '/podium/tarnet-examples.jpg',
    accent: '#3E5F4C',
    accentName: 'forest',
    client: 'Podium',
    role: 'Praktikant — Studentermedhjælper',
    tools: 'Illustrator, InDesign, Photoshop, Figma',
    liveUrl: 'https://restaurantpodium.dk/',
    liveLabel: 'restaurantpodium.dk',
    summary: 'Et praktikforløb hos Podium — hvor jeg arbejder på visuelle identiteter, designguides og en samlet hjemmeside for Restaurant Podium, Aalborgtårnet og Skydepavillonen. Tre søskendebrands i AKKC-familien, der hver især skulle have deres egen tone — og samtidig dele en fælles typografisk og visuel rytme, der ender hos gæsten på restaurantpodium.dk.',
    sections: [
      // === PRODUKTER FØRST (visuals) ===
      { type: 'chapter', heading: 'Aalborgtårnet & Skydepavillonen', id: 'ch-identitet' },
      { type: 'video', src: '/podium/podium-animation.mp4', poster: '/podium/podium-animation-poster.jpg', caption: 'Podium — brandet i bevægelse.', aspect: '16 / 9', autoplay: true, loop: true },
      { type: 'image', src: '/podium/tarnet-examples.jpg', caption: 'Aalborgtårnet — Eksempler: menukort, tote bags, skiltning og hjemmeside.', aspect: '2800 / 396', fit: 'contain' },
      { type: 'image', src: 'https://customer-assets.emergentagent.com/job_film-craft-studio-2/artifacts/cahh4fy4_menukort%201-%20t%C3%A5rnet-mockup.png', caption: 'Aalborgtårnet — menukort i restaurant (real-world mockup).' },
      { type: 'image', src: '/podium/tarnet-cover.jpg', caption: 'Aalborgtårnet — Officielle Designguide, forside.' },
      { type: 'image', src: '/podium/tarnet-logo-grid.jpg', caption: 'Aalborgtårnet — Logos Grid: konstruktion og frizone.', aspect: '2200 / 518', fit: 'contain' },
      { type: 'image', src: '/podium/tarnet-typography.jpg', caption: 'Aalborgtårnet — Typografi (TT Norms).', aspect: '1800 / 636', fit: 'contain' },
      { type: 'image', src: '/podium/skyde-examples.jpg', caption: 'Skydepavillonen — Eksempler: selskabsskilte, webside og uniform.', aspect: '2800 / 495', fit: 'contain' },
      { type: 'image', src: '/podium/skyde-cover.jpg', caption: 'Skydepavillonen — Officielle Designguide, forside.' },
      { type: 'image', src: '/podium/skyde-logo-grid.jpg', caption: 'Skydepavillonen — Logos Grid: konstruktion og frizone.', aspect: '2200 / 518', fit: 'contain' },
      { type: 'chapter', heading: 'restaurantpodium.dk', id: 'ch-web' },
      { type: 'image', src: '/podium/web/home-hero.jpg', caption: 'restaurantpodium.dk — forsidens hero med wordmark over festscene.', aspect: '1440 / 900' },
      { type: 'image', src: '/podium/web/menu.jpg', caption: 'restaurantpodium.dk — "vores menu" med varm restaurant-stemning.', aspect: '1440 / 900' },
      { type: 'image', src: '/podium/web/selskaber.jpg', caption: 'restaurantpodium.dk — selskaber, et kort-system per anledning.', aspect: '1440 / 900' },
      { type: 'image', src: '/podium/web/bryllup.jpg', caption: 'restaurantpodium.dk — bryllup, en dedikeret atmosfære per fest.', aspect: '1440 / 900' },
      { type: 'image', src: '/podium/web/julefrokost.jpg', caption: 'restaurantpodium.dk — julefrokost, samme system, ny tone.', aspect: '1440 / 900' },
      { type: 'image', src: '/podium/web/mobile-home.jpg', caption: 'Mobil — hjemmesiden i lommen, samme system, kompakt rytme.', aspect: '390 / 844', fit: 'contain' },
      { type: 'chapter', heading: 'Fysiske produkter', id: 'ch-fysisk' },
      { type: 'image', src: '/podium/togo-2.jpg', caption: 'To-go pose — "Nyd forkælelsen, du har helt sikkert fortjent den."', aspect: '1800 / 1584', fit: 'contain' },
      { type: 'image', src: '/podium/togo-1.jpg', caption: 'To-go pose — "til enhver anledning".', aspect: '1800 / 1584', fit: 'contain' },
      { type: 'image', src: '/podium/togo-4.jpg', caption: 'To-go pose — varianter i systemet.', aspect: '1800 / 1584', fit: 'contain' },
      { type: 'image', src: '/podium/tshirt-front-1.jpg', caption: 'T-shirt til personale — forside med Podium-logo.', aspect: '1400 / 1979', fit: 'contain' },
      { type: 'image', src: '/podium/tshirt-back-1.jpg', caption: 'T-shirt til personale — bagside med Aalborgtårnet og Skydepavillonen.', aspect: '1400 / 1979', fit: 'contain' },
      { type: 'image', src: '/podium/tshirt-front-2.jpg', caption: 'T-shirt — variant til uniform.', aspect: '1400 / 1979', fit: 'contain' },
      // === REFLEKSIONER TIL SIDST (tekster) ===
      { type: 'chapter', heading: 'Refleksioner', id: 'ch-refleksioner' },
      { type: 'text', heading: 'Aalborgtårnet & Skydepavillonen — visuel identitet', body: 'Podium er én restaurant med to husrum: det varme, åbne Aalborgtårnet på toppen af byen, og den mere afdæmpede Skydepavillonen nede i skoven. Redesignet af den visuelle identitet handler om at give hvert hus sit eget udtryk — men samtidig binde dem sammen som familie gennem en fælles typografisk og visuel rytme. Fra logo-monogrammer og typografi til menukort, skiltning og applikationer på tværs af begge huse.' },
      { type: 'text', heading: 'restaurantpodium.dk — brandet i live drift', body: 'Sidste led i kæden: hjemmesiden. Hele identitetssystemet — wordmark, mørkegrøn, gylden mustard, TT Norms-typografien — er trukket ud i en interaktiv flade på restaurantpodium.dk. Her møder gæsten brandet første gang, før de overhovedet sætter sig til bords.' },
      { type: 'text', heading: 'Fysiske produkter — brandet i hånden', body: 'Ud over designguides og hjemmeside strækker systemet sig ind i det taktile: genbrugelige to-go poser med en varm hilsen, og t-shirts til personalet der bærer brandet direkte fra køkkenet ud til gæsten. Samme typografi, samme tone, blot i papir og bomuld.' }
    ]
  },
  {
    id: 'anonyme-alkoholikere',
    slug: 'anonyme-alkoholikere',
    title: 'Webdesign',
    subtitle: 'Anonyme Alkoholikere',
    category: 'Webdesign',
    year: '2025',
    descriptor: 'Fiktiv opgave — landingpage med fokus på letlæselighed og enkel CTA.',
    cover: img('553603c9-bf71-4207-a126-81b2149cb12f_carw_4x3x5120.png', '157acc860d979eda050ef54e2154ca61'),
    accent: '#B3543E',
    accentName: 'terracotta',
    client: 'Skoleopgave (Fiktiv)',
    role: 'Designer',
    tools: 'Adobe XD, Photoshop',
    summary: 'En fiktiv opgave til Anonyme Alkoholikere — en landingpage bygget op om to principper: enkel læsning og en CTA der er let at finde, uanset hvilken tilstand brugeren ankommer i.',
    sections: [
      // === PRODUKTER FØRST ===
      { type: 'image', src: img('553603c9-bf71-4207-a126-81b2149cb12f_carw_4x3x5120.png', '157acc860d979eda050ef54e2154ca61'), caption: 'Landingpage — endeligt design.' },
      // === REFLEKSIONER TIL SIDST ===
      { type: 'text', heading: 'Letlæselighed først', body: 'Typografien er sat med rigeligt luft. Hierarkiet er afdæmpet. CTA’en sidder i øjenhøjde og forbliver der, mens man scroller — fordi det her er en side man finder, når man har brug for at handle, ikke for at læse.' }
    ]
  },
  {
    id: 'sangiovanni-jul',
    slug: 'sangiovanni-jul',
    title: 'Eventdesign',
    subtitle: 'SanGiovanni Julearrangement',
    category: 'Event',
    year: '2024',
    descriptor: 'Skoleopgave — visuelt univers til SanGiovannis julearrangement.',
    cover: img('0af220ef-1df8-4bbd-958f-32a7be24d527_rw_1200.png', '508a62dd5ead790d914c0385cee4dd94'),
    accent: '#3E5F4C',
    accentName: 'forest',
    client: 'Skoleopgave (UCN)',
    role: 'Grafisk Designer',
    tools: 'Illustrator, InDesign, Photoshop',
    summary: 'En skoleopgave hvor det visuelle univers til SanGiovannis julearrangement skulle skabes — fra plakat til menukort. Resultatet er en stille, varm julestemning, der lader maden og lyset stå tilbage som hovedpersonerne.',
    sections: [
      // === PRODUKTER FØRST ===
      { type: 'image', src: img('5f0601e7-9eea-4b1a-ae85-9f50a099d49e_rw_1920.jpg', '8a07b2788c5052b4c2001992c9060389'), caption: 'Plakat — primær visuel.' },
      { type: 'image', src: img('a5be3424-ab69-4828-8b2b-5db25fde5d6e_rw_1920.jpg', '1cec948f3979d7096133a6deed4c398c'), caption: 'Skiltning og applikationer.' },
      { type: 'image', src: img('7ed643f7-64dc-4e88-990f-2f771f8f5d77_rw_1200.jpg', '47ce6ee8a47732259d11503de593941a'), caption: 'Detalje — menu og kort.' },
      { type: 'image', src: img('ebd668a8-6560-46ac-939e-df294e82b46b_rw_1200.jpg', '1f1f575309c0bd656c9431c991a4967d'), caption: 'Applikation — udvalgte rammer.' },
      { type: 'image', src: img('8faf2e5f-5fb2-4e1a-9acb-0afc6de19147_rw_1200.jpg', 'faef6f1d15afc776de1958ba6dc9c43d'), caption: 'Applikation i rummet.' },
      { type: 'image', src: img('0f2b78bb-a346-4885-a2b2-6b1c53cf9d1e_rw_1200.jpg', '136cec231334febc78cebccd27cb4a22'), caption: 'Print — endelig produktion.' },
      // === REFLEKSIONER TIL SIDST ===
      { type: 'text', heading: 'Et varmt univers', body: 'Farveholdningen er trukket fra et glas vin og et tændt lys. Typografien er klassisk, men sat løst — som en hilsen, ikke et skilt.' }
    ]
  },
  {
    id: 'hjort-beer-house',
    slug: 'hjort-beer-house',
    title: 'Brandidentitet',
    subtitle: 'Hjort Beer House',
    category: 'Identitet',
    year: '2025',
    descriptor: 'UCN gruppearbejde — komplet visuel identitet til et lokalt bryggeri.',
    cover: img('c42fa401-8ae2-44bf-88c9-cdbcc6fce345_rw_1920.jpg', 'b153e5ddc154b07daa05c31d4981fdff'),
    accent: '#E8B33C',
    accentName: 'mustard',
    client: 'Hjort Beer House',
    role: 'Grafisk Designer — gruppearbejde (UCN)',
    tools: 'Illustrator, InDesign, Photoshop',
    summary: 'Et fuldt visuelt identitetssystem til Hjort Beer House — udviklet i gruppearbejde på UCN. Et hus til øl skulle have en identitet, der både kunne klæde den varme stemning ved baren og den nøgterne klarhed på etiketten.',
    sections: [
      // === PRODUKTER FØRST ===
      { type: 'image', src: img('d4e94e7d-dfc0-43c5-922b-66b84176a99c_rw_1920.jpg', '28fab9705a0c783060675ac276afa2f1'), caption: 'Identitetsplade — primær applikation.' },
      { type: 'image', src: img('7497cc5a-a91d-4a8c-9460-6d6b9ca4ef6f_rw_1920.jpg', '6143118303479f4ae5b566cf1a974a28'), caption: 'Etiketter og emballage.' },
      { type: 'image', src: img('65905962-93af-4343-a655-772a90761785_rw_1920.jpg', '1c249458b41af98b6482f247ddfb7b09'), caption: 'Applikationer i rummet.' },
      { type: 'image', src: img('3b05db03-ece9-4554-925c-ba3293fd75b1_rw_1920.jpg', '49f5cc05f84c57563e0b758d882c7d7d'), caption: 'Systemet i kontekst.' },
      { type: 'image', src: img('dd241bb6-6f0b-413e-8c2e-9f5bffaf951d_rw_1920.jpg', '6c6148aa662c61a59effefbac9d6e859'), caption: 'Detalje — typografi og tekstur.' },
      // === REFLEKSIONER TIL SIDST ===
      { type: 'text', heading: 'En identitet der holder på begge sider af baren', body: 'Logoet er trukket fra en hjortes silhuet — robust, lavmælt, men umiskendelig. Farveholdningen veksler mellem varm okker og dyb skov, alt efter konteksten.' }
    ]
  },
  {
    id: 'shaping-new-tomorrow',
    slug: 'shaping-new-tomorrow',
    title: 'Samarbejde',
    subtitle: 'Shaping New Tomorrow',
    category: 'Brand collab',
    year: '2024',
    descriptor: 'Samarbejde med Shaping New Tomorrow — visuelt indhold og brandformidling.',
    cover: img('5cb08501-3cbc-46d5-8257-914278d811d5_rw_1920.jpg', '6814b8e4ee2a1578580c295e2107bcd7'),
    accent: '#4A6B82',
    accentName: 'steel',
    client: 'Shaping New Tomorrow',
    role: 'Grafisk Designer',
    tools: 'Photoshop, Illustrator, InDesign',
    summary: 'Et samarbejde med Shaping New Tomorrow — visuelt indhold der balancerer brandets nordiske klarhed med en mere personlig, taktil tone. Fokus på fotostil, layout og rytme.',
    sections: [
      // === PRODUKTER FØRST ===
      { type: 'image', src: img('00c9fd5c-c5cf-4ea7-a2f1-5b9546423767_rw_1920.jpg', '7bbef90797090c03db43f9b6d990159f'), caption: 'Visuelt indhold — udvalgte rammer.' },
      { type: 'image', src: img('83d2e1a8-d4bd-4a4d-9fab-c16cb00def57_rw_1920.jpg', '4f4ee12b23058be080244df6561df5fa'), caption: 'Layout og rytme.' },
      { type: 'image', src: img('31195a6f-bf16-4f5e-bcf1-6b8986834a8a_rw_1200.jpg', 'cca921f2242863b60843be4a3556ba64'), caption: 'Detalje — typografi i kontekst.' },
      { type: 'image', src: img('5772c429-c0a8-454e-8557-c24d08212fb2_rw_1200.jpg', '22bc61e6bf3ad0ce03a3fbfe4efe91c8'), caption: 'Applikation i kontekst.' },
      { type: 'image', src: img('032f5304-aaf3-45d1-8f99-d25e9f6cc27c_rw_1200.jpg', '85865e3db076b6070905343cac01651b'), caption: 'Visuelt indhold — udvidet.' },
      { type: 'image', src: img('465de2ba-75af-49a7-981d-87fdad63303b_rw_1920.jpg', '5dc31dcc4a67c716771e38bbe9f75eaf'), caption: 'Helheden samlet.' },
      // === REFLEKSIONER TIL SIDST ===
      { type: 'text', heading: 'En tone der kan klæde sig på og af', body: 'Brandets klarhed er bevaret, men formatet er trukket tættere på læseren — som et brev frem for en annonce.' }
    ]
  },
  {
    id: 'exakt',
    slug: 'exakt',
    title: 'Brandidentitet',
    subtitle: 'Exakt',
    category: 'Identitet',
    year: '2024',
    descriptor: 'UCN gruppearbejde — visuel identitet udviklet i fællesskab.',
    cover: img('47597b06-4b10-4cc4-880d-9442443fa22e_rw_1920.jpg', '1b12a6e302c68fc82922cb838cdc19ce'),
    accent: '#B3543E',
    accentName: 'terracotta',
    client: 'Exakt',
    role: 'Grafisk Designer — gruppearbejde (UCN)',
    tools: 'Illustrator, InDesign',
    summary: 'En visuel identitet udviklet i gruppearbejde på UCN. Navnet ledte os mod en typografisk præcision — alt sat med matematisk omhu, men aldrig stift.',
    sections: [
      // === PRODUKTER FØRST ===
      { type: 'image', src: img('47597b06-4b10-4cc4-880d-9442443fa22e_rw_1920.jpg', '1b12a6e302c68fc82922cb838cdc19ce'), caption: 'Identitet — primær applikation.' },
      { type: 'image', src: img('6e6181a7-4abc-4e63-ad41-f581ee8c44d7_rw_1920.jpg', '7df4df3bbf1009c3381fb832d4381f9d'), caption: 'Layout og system.' },
      { type: 'image', src: img('263059dc-5351-4b09-8d5c-876f22d6e2a6_rw_1920.jpg', '4a336ea9c4874c2a57835e14ac82f8ab'), caption: 'Applikation i kontekst.' },
      // === REFLEKSIONER TIL SIDST ===
      { type: 'text', heading: 'Typografi som hovedmotiv', body: 'Hele systemet hviler på et omhyggeligt arbejde med opslagsproportioner. Hver detalje er sat med matematisk omhu — men aldrig stift.' }
    ]
  },
  {
    id: 'aalborg-atletik-motion',
    slug: 'aalborg-atletik-motion',
    title: 'Sportsbranding',
    subtitle: 'Aalborg Atletik & Motion',
    category: 'Brand',
    year: '2024',
    descriptor: 'Samarbejde med Aalborg Atletik & Motion — visuelt design til klubben.',
    cover: img('95423fef-e9be-49a6-a5cc-8063706e5733_rw_1920.jpg', '8fe887c079bbffd9bc7d65d3658beda3'),
    accent: '#3E5F4C',
    accentName: 'forest',
    client: 'Aalborg Atletik & Motion',
    role: 'Grafisk Designer',
    tools: 'Illustrator, Photoshop',
    summary: 'Et samarbejde med Aalborg Atletik & Motion — visuelt design der forbinder klubbens lokale stolthed med en moderne, dynamisk udtryksform.',
    sections: [
      // === PRODUKTER FØRST ===
      { type: 'image', src: img('7251017d-0244-49bd-9110-ef634bec339f_rw_1200.jpg', 'b53e00a516d1bfcd1f48bf3f88d499d4'), caption: 'Visuelt design — primært udtryk.' },
      { type: 'image', src: img('0745c709-b401-4138-bf63-7ce7bb53da27_rw_1920.jpg', '947e89141a2e8b6fcf07822652d18b7d'), caption: 'Applikationer.' },
      { type: 'image', src: img('0d639cd4-29f7-42ad-8764-177f51d860ea_rw_1200.jpg', '6deb9ca30c37794e37e66e97ee64acd4'), caption: 'Detalje — udtryk i kontekst.' },
      { type: 'image', src: img('2aa7f622-ca89-4746-8ef2-a1622a2ee480_rw_1200.jpg', '77e5be76b2387b68aeae3e85685c529d'), caption: 'Print — endelig produktion.' },
      { type: 'image', src: img('324e4da8-d7d8-4631-8197-4b95253f58e6_rw_1920.jpg', '97604079eb0e9f0cc489352e1722c579'), caption: 'Helhed i kontekst.' },
      // === REFLEKSIONER TIL SIDST ===
      { type: 'text', heading: 'Klubbens egen takt', body: 'Identiteten er bygget op om en dynamisk geometri — bevægelse fastfrosset midt i et skridt. Farverne er hentet fra klubbens historie.' }
    ]
  }
];

// 3 udvalgte cases til hjemmesidens horisontale carousel (Podium nyest, Hjort, AA Motion)
export const featuredCases = [cases[0], cases[3], cases[6]];

export const philosophy = {
  heading: 'Design, formidlet som film.',
  body: 'Hvert brand er en historie, der venter på sit første billede. Jeg arbejder i rummet mellem film og design — og komponerer identiteter, der holder en tone, som et langt indstilling holder en stemning. Strategisk, autentisk og stille filmisk.'
};

export const navLinks = [
  { label: 'Arbejde', to: '/work' },
  { label: 'Om mig', to: '/about' },
  { label: 'Kontakt', to: '/contact' }
];

export const ui = {
  scroll: 'Rul',
  swipe: 'Svøb',
  viewCase: 'Se case',
  nextCase: 'Næste case',
  allWork: 'Alle arbejder',
  overview: 'Overblik',
  getInTouch: 'Kom i kontakt',
  startProject: 'Start et projekt',
  copyEmail: 'Kopiér email',
  copied: 'Kopieret til udklipsholder',
  primaryEmail: 'Primær — Email',
  connect: 'Forbind',
  located: 'Beliggenhed',
  phone: 'Telefon',
  follow: 'Følg',
  navigate: 'Naviger',
  elsewhere: 'Andre steder',
  meta: { client: 'Kunde', year: 'År', role: 'Rolle', tools: 'Værktøjer' }
};
